import { Badge } from "@/components/ui/badge";

const STATUS_MAP: Record<string, { label: string; variant: "default" | "secondary" | "destructive" | "outline"; className?: string }> = {
  PENDENTE: { label: "Pendente", variant: "outline", className: "border-slate-300 text-slate-600" },
  COLETA_EM_ANDAMENTO: { label: "Em Coleta", variant: "secondary", className: "bg-blue-100 text-blue-700 border-blue-200" },
  AVALIACAO_CONCLUIDA: { label: "Concluída", variant: "default", className: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  AVALIACAO_BLOQUEADA_SEM_RESPOSTAS: { label: "Bloq. Sem Respostas", variant: "destructive", className: "bg-red-100 text-red-700 border-red-200" },
  AVALIACAO_BLOQUEADA_DADOS_INSUFICIENTES: { label: "Bloq. Dados Insuf.", variant: "destructive", className: "bg-orange-100 text-orange-700 border-orange-200" },
  DRAFT: { label: "Rascunho", variant: "outline", className: "border-slate-300 text-slate-500" },
  ACTIVE: { label: "Ativa", variant: "default", className: "bg-blue-100 text-blue-700 border-blue-200" },
  CLOSED: { label: "Encerrada", variant: "secondary", className: "bg-slate-100 text-slate-600 border-slate-200" },
};

export function StatusBadge({ status }: { status: string }) {
  const config = STATUS_MAP[status] || { label: status, variant: "outline" as const };
  return (
    <Badge variant={config.variant} className={`text-xs font-medium ${config.className || ""}`}>
      {config.label}
    </Badge>
  );
}

const STAGE_COLORS: Record<string, string> = {
  "Não iniciado": "bg-slate-100 text-slate-600 border-slate-200",
  "Importação realizada": "bg-violet-100 text-violet-700 border-violet-200",
  "Campanha criada": "bg-blue-100 text-blue-700 border-blue-200",
  "Coleta em andamento": "bg-cyan-100 text-cyan-700 border-cyan-200",
  "Avaliação concluída": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Documento gerado": "bg-green-100 text-green-800 border-green-200",
};

export function StageBadge({ stage }: { stage: string }) {
  const className = STAGE_COLORS[stage] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <Badge variant="outline" className={`text-xs font-medium ${className}`}>
      {stage}
    </Badge>
  );
}
